<template>
	<div class="toast-container position-fixed top-0 p-3">
		<div id="correctlyToast" class="toast align-items-center toast-success" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="d-flex">
				<div class="toast-body">
					{{toast.toastMessage}}
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>
		<div id="incorrectlyToast" class="toast align-items-center toast-danger" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="d-flex">
				<div class="toast-body">
					{{toast.toastMessage}}
				</div>
				<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
		</div>
	</div>
</template>

<script>
import * as bootstrap from "bootstrap";
import {mapGetters} from "vuex";


export default {
	name: 'ToastWelcom',
	emits: [],
	computed: {
		...mapGetters('wePass', ["toast"]),
	},
	mounted() {

	},
	beforeUnmount() {

	},
	watch: {
		toast(newValue, oldValue){
			console.log('Cambiando el valor de la valiable computada', newValue, oldValue)
			if(newValue.showToast === true){
				this.showToast();
			}
			if(newValue === false){
				this.showToast('scannerIncorrectly');
			}
		}
	},
	methods: {
		showToast() {
			console.log('vamos a mostrar l tast', this.toast.idToast)
			const toastElement = document.getElementById(this.toast.idToast);
			const toastInstance = bootstrap.Toast.getOrCreateInstance(toastElement);
			toastInstance.show();
		}
	}
}
</script>
